const O = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.719 47.72">
            <path d="M768.228,1377.45a24.044,24.044,0,0,0,0,23.97,23.842,23.842,0,0,0,8.7,8.67,23.975,23.975,0,0,0,23.933,0,23.842,23.842,0,0,0,8.7-8.67,24.044,24.044,0,0,0,0-23.97,23.771,23.771,0,0,0-8.7-8.7,23.975,23.975,0,0,0-23.933,0A23.771,23.771,0,0,0,768.228,1377.45Zm14,12a6.5,6.5,0,0,1,1.933-4.73,6.672,6.672,0,0,1,9.467,0,6.766,6.766,0,0,1,0,9.47,6.7,6.7,0,0,1-9.467,0A6.525,6.525,0,0,1,782.228,1389.45Z" transform="translate(-765.031 -1365.56)"/>
        </svg>
    )
}

export default O